import { api } from '@/lib/api';
import type { ShiftSummary, ShiftWithTotals } from './schemas';

export interface ListShiftsParams {
  month: string;
  cnpjId?: string | null;
  serviceId?: string | null;
}

export interface CreateShiftPayload {
  serviceId: string;
  date: string;
  overrideFixedValue?: number | null;
  notes?: string | null;
}

export interface UpdateShiftPayload {
  overrideFixedValue?: number | null;
  notes?: string | null;
}

export const shiftsApi = {
  list: (params: ListShiftsParams) =>
    api.get<ShiftWithTotals[]>('/shifts', {
      month: params.month,
      cnpjId: params.cnpjId ?? undefined,
      serviceId: params.serviceId ?? undefined,
    }),

  create: (payload: CreateShiftPayload) => api.post<ShiftWithTotals>('/shifts', payload),

  update: (id: string, payload: UpdateShiftPayload) =>
    api.patch<ShiftWithTotals>(`/shifts/${id}`, payload),

  remove: (id: string) => api.delete<void>(`/shifts/${id}`),

  start: (id: string) => api.post<ShiftWithTotals>(`/shifts/${id}/start`),
  end: (id: string) => api.post<ShiftWithTotals>(`/shifts/${id}/end`),
  reopen: (id: string, reason: string) =>
    api.post<ShiftWithTotals>(`/shifts/${id}/reopen`, { reason }),

  registerItem: (id: string, examTypeId: string, quantity?: number) =>
    api.post<ShiftWithTotals>(`/shifts/${id}/items`, { examTypeId, quantity }),

  undoLastItem: (id: string) => api.delete<ShiftWithTotals>(`/shifts/${id}/items/last`),

  removeItem: (id: string, examTypeId: string) =>
    api.delete<ShiftWithTotals>(`/shifts/${id}/items/${examTypeId}`),

  summary: (id: string) => api.get<ShiftSummary>(`/shifts/${id}/summary`),
};
